import DashboardComponentWrapper from "../../../components/dashboard/DashboardComponentWrapper";
import Table from '../../../components/ui/Table';
import CopyData from '../../../components/ui/CopyData';

export default function ContributionTypesDetails() {
  return (
    <DashboardComponentWrapper
      title="Contribution Types"
      pageDetails="These are the contribution codes used across the pension platform. Review the code, name, and meaning for each contribution type below."
    >
      <div className="mt-6 w-full">
        <ContributionTypesTable />
      </div>
    </DashboardComponentWrapper>
  )
}

const contributionTypes = [
  {
    code: "MAN",
    name: "Mandatory",
    description: "This is the contribution mandated by law monthly i.e. EE & ER contribution"
  },
  {
    code: "ADD",
    name: "Additional Contribution",
    description: "This will be used for any additional contribution for any month that has been previously paid"
  },
  {
    code: "PEN",
    name: "Penalty",
    description: "This is the penalty levied to employers for late remittances"
  },
  {
    code: "ARR",
    name: "Arrears",
    description: "This is the contributions previously missed by employers"
  },
  {
    code: "ACR",
    name: "Accrued Rights",
    description: "This is the payments made by Federal goverment for retiring employees in Public sector"
  },
  {
    code: "BON",
    name: "State Bonds (Accrued Rights)",
    description: "This is the payments made by State government for retiring employees"
  },
  {
    code: "UPF",
    name: "Pension from Upfront (Housing etc)",
    description: "This is a payment made by some self funding public sectors within the year"
  },
  {
    code: "OFF",
    name: "Off-Cycle",
    description: "This is a payment made by some self funding public sectors within the year"
  },
  {
    code: "13T",
    name: "Pension from 13th Month",
    description: "This is a payment made by employers who pay 13th month salary "
  },
  {
    code: "14T",
    name: "Pensions from 14th Month",
    description: "This is a payment made by employers who pay 14th month salary "
  },
  {
    code: "OTH",
    name: "Others",
    description: "This is an other kind of payment outside what has been stated here, this should be described properly by the employer"
  },
  {
    code: "INC",
    name: "Pension Increases",
    description: "Any kind of pension increases paid to Retirees"
  },
  {
    code: "HOU",
    name: "Housing Allowance or Rent",
    description: "Used by some employers who makes pension contributions from Housing or Rent Allowances"
  },
  {
    code: "PRE",
    name: "Pre-CPS Contributions such as NSITF",
    description: "This is a pre CPS contribution such as the NSITF scheme"
  },
  {
    code: "SHO",
    name: "Shortfalls",
    description: "Any shortfall payments based on rate increments"
  }
];

const header = [
  {
    field: 'code',
    headerName: 'Code',
    filter: true,
    cellRenderer: ({ data }: any) => (
      <div className="flex items-center gap-2">
        <span className="font-semibold text-az-teal">{data.code}</span>
        <CopyData data={data.code} />
      </div>
    )
  },
  {
    field: 'name',
    headerName: 'Name',
    filter: true,
    cellRenderer: ({ data }: any) => (
      <div className="font-medium text-gray-800">{data.name}</div>
    )
  },
  {
    field: 'description',
    headerName: 'Description',
    filter: true,
    flex: 1,
    cellRenderer: ({ data }: any) => (
      <div className="leading-relaxed text-gray-700" title={data.description}>
        {data.description}
      </div>
    )
  }
];

const ContributionTypesTable = () => {
  return (
    <div className="!w-full h-[90vh] text-left">
      <Table data={contributionTypes} header={header} isRowSelectable={false} checkboxSelect={false} />
    </div>
  )
}